var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMemo, useState } from "react";
import { useShoppingCart } from "@/react/Webshop/providers/ShoppingCartProvider";
import useTemplateInstance from "@/react/hooks/useTemplateInstance";
import { usePriceList } from "@/react/Webshop/providers/PriceListProvider";
import { getTemplateTranslation } from "@/react/Providers/TemplateInstanceProvider";
import { useTranslation } from "react-i18next";
export const useBuyTemplateProduct = ({ onAddedToCart, }) => {
    const [state] = useTemplateInstance();
    const product = state.product;
    const { addMultipleItems, qualifyForPromotedPrice } = useShoppingCart();
    const { productHasCampaign, calculateLinePrice } = usePriceList();
    const [isUpdating, setIsUpdating] = useState(false);
    const { i18n } = useTranslation();
    const [quantity, setQuantity] = useState(() => {
        const q = {};
        if (!product.subproducts || product.subproducts.length === 0) {
            q[product.uuid] = product.minorderpartquantity;
        }
        return q;
    });
    console.log("Product is", product);
    const hasCampaignPrice = useMemo(() => state.template.categories.some((category) => productHasCampaign(product, category)), [product, state]);
    const totalQuantity = useMemo(() => {
        return Object.values(quantity).reduce((sum, val) => sum + (isNaN(val) ? 0 : Number(val)), 0);
    }, [quantity]);
    const totalPrice = useMemo(() => {
        return Object.keys(quantity).reduce((sum, uuid) => {
            const qty = quantity[uuid];
            if (qty && !isNaN(qty)) {
                return (sum +
                    calculateLinePrice(product.uuid, qty, uuid, hasCampaignPrice, qualifyForPromotedPrice));
            }
            return sum;
        }, 0);
    }, [quantity]);
    const updateQuantity = (uuid, value) => {
        setQuantity((prev) => (Object.assign(Object.assign({}, prev), { [uuid]: value })));
    };
    const handleAddToCart = () => __awaiter(void 0, void 0, void 0, function* () {
        const resources = Object.values(state.resources)
            .filter((r) => r.userSupplied)
            .reduce((acc, r) => {
            acc[r.fullId] = r;
            return acc;
        }, {});
        const products = Object.keys(quantity).reduce((list, uuid) => {
            const qty = quantity[uuid];
            if (qty >= product.minorderpartquantity) {
                // Hack, quantity with the same uuid as the product uuid
                if (uuid === product.uuid) {
                    uuid = "";
                }
                list.push({
                    type: product.type,
                    product,
                    subProductUuids: uuid ? [uuid] : [],
                    quantity: qty,
                    template: {
                        uuid: state.template.uuid,
                        name: getTemplateTranslation(state.template.name, i18n.language),
                        categories: state.template.categories,
                        data: {
                            year: state.year,
                            userResources: resources,
                        },
                    },
                    // Placeholders, not used. Make a proper datatype
                    canChangeQuantity: true,
                    linePrice: 0,
                    uuid: "",
                    actualLinePrice: 0,
                    description: "",
                    rebate: null,
                    isUpdating: false,
                    isDeleting: false,
                    locked: false,
                    minimumQuantity: 1,
                    maximumQuantity: 1,
                    vat: 0,
                    photographers: [],
                    edit: {
                        text: "",
                        link: "",
                    },
                });
            }
            return list;
        }, []);
        setIsUpdating(true);
        try {
            const serverResponse = yield addMultipleItems(products);
            onAddedToCart(serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.newOrderLines);
        }
        catch (err) {
            // FIXME: Add error state and display it
            setIsUpdating(false);
        }
    });
    return {
        product,
        quantity,
        updateQuantity,
        totalQuantity,
        totalPrice,
        hasCampaignPrice,
        isUpdating,
        handleAddToCart,
        qualifyForPromotedPrice,
        setQuantity,
    };
};
